export class Parameter {
  constructor({name, type, defaultValue, maxLength} = {}) {
    this.name = name;
    this.type = type;
    this.defaultValue = defaultValue;

    if (maxLength) {
      this.maxLength = maxLength;
    } else if (type === 'array') {
      this.maxLength = Infinity;
    } else {
      this.maxLength = 1;
    }
  }
}